import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Button, Div, Flex, Gutter } from '@gaiads/telia-react-component-library';

export interface BottomDrawerProps<T> {
  selectedItems: T[];
  handleEditClick: (item: T) => void;
  handleDeleteClick: () => void;
  handleCancelClick: () => void;
  handleAddClick: () => void;
  editButtonText: string;
  selectedText: string;
}

export default function BottomDrawer<T>({
  selectedItems,
  handleEditClick,
  handleDeleteClick,
  handleCancelClick,
  handleAddClick,
  editButtonText,
  selectedText,
}: BottomDrawerProps<T>) {
  const { t } = useTranslation('productsscreen');
  const EditButton = () => (
    <Button
      variant={'primaryWhite'}
      onClick={() => {
        handleEditClick(selectedItems[0]);
      }}
    >
      {editButtonText}
    </Button>
  );
  const isSingleItem = selectedItems.length === 1;

  return (
    <div className="sticky-footer">
      <Div margin={{ horizontal: 'xxlg', vertical: 'md' }}>
        <Flex padding={{ horizontal: 'md' }}>
          <Flex flexItem alignBaseline spaceBetween>
            <Flex flexItem alignBaseline>
              <BodyText color={'white'}>{selectedText}</BodyText>
              <Gutter />
              {isSingleItem && (
                <>
                  <Button variant={'primaryWhite'} onClick={() => handleAddClick()}>
                    {t('selected.addToChannel')}
                  </Button>
                  <Gutter />
                  <EditButton />
                  <Gutter />
                </>
              )}

              <Button onClick={() => handleDeleteClick()} variant={'destructive'}>
                {t('selected.delete')}
              </Button>
              <Flex />
              <Flex flexItem alignBaseline alignRight>
                <Button textVariantProps={{ color: 'white' }} size={'xl'} onClick={() => handleCancelClick()} variant={'text'}>
                  {t('selected.cancel')}
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Div>
    </div>
  );
}
